import React from "react";
import classes from "./ProgressLoader.module.scss";
import classNames from "classnames";

export default ({percent, thumbClassName, thumbStyle, className, style, indeterminate, small, color = "default"}) => {
    return <div className={classNames(classes.track, className, {[classes['indeterminate']]: indeterminate, [classes['small']]: small})} style={style}>
        <div className={classNames(classes.thumb, thumbClassName, classes[color])} style={{...thumbStyle, width: indeterminate ? undefined : `${percent}%`}}/>
    </div>
};
